"use client"

import { useState } from "react"
import styles from "./TextArea.module.css"

const TextArea = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  disabled = false,
  error,
  success,
  maxLength,
  required = false,
  resize = "vertical",
  ...props
}) => {
  const [focused, setFocused] = useState(false)

  const textareaClasses = [
    styles.textarea,
    error && styles.error,
    success && styles.success,
    disabled && styles.disabled,
    focused && styles.focused,
    styles[resize],
  ]
    .filter(Boolean)
    .join(" ")

  const characterCount = value ? value.length : 0
  const showCharacterCount = maxLength && maxLength > 0

  return (
    <div className={styles.container}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div className={styles.textareaWrapper}>
        <textarea
          className={textareaClasses}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          {...props}
        />
        {showCharacterCount && (
          <div className={styles.characterCount}>
            <span className={characterCount > maxLength * 0.9 ? styles.warning : ""}>{characterCount}</span>/{maxLength}
          </div>
        )}
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  )
}

export default TextArea
